//
//
//
//
//
//
//
//
//
//
//
//
import { logoOut } from '@data/user';
import { getToken } from '@/utils/auth';
export default {
  name: 'App',
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('beforeunload', function (e) {
      return _this.beforeunloadHandler(e);
    });
  },
  destroyed: function destroyed() {
    var _this2 = this;

    window.removeEventListener('beforeunload', function (e) {
      return _this2.beforeunloadHandler(e);
    });
  },
  methods: {
    beforeunloadHandler: function beforeunloadHandler() {
      var token = getToken();

      if (token) {
        return;
      } else {
        logoOut();
      }
    }
  }
};